export const GET_TOTAL_STATS = 'CDL/get_total_stats';
export const GET_GRAPH_STATS = 'CDL/get_graph_stats';

export const CEDULA = [
    { name: 'INDIVIDUAL', color: '#5272AA', value: 0 },
    { name: 'CORPORATION', color: '#8EEED7', value: 0 },
];